import React from 'react';
import PropTypes from 'prop-types';
import {
  getDayClassName,
  getDayStatuses,
  getDayVisualStatus,
  WEEKDAYS,
} from './utils/PreventiveTaskProjectionCalendarUtils';
import { PREVENTIVE_TASK_STATUS_ACTIVITY } from '../../../../config/constants';

const PreventiveTaskProjectionMonthGrid = ({
  weeks,
  itemsByDate,
  selectedDateKey,
  onSelectDate,
}) => (
  <div className="pt-calendar">
    <div className="pt-calendar-weekdays">
      {WEEKDAYS.map((weekday) => (
        <div key={weekday} className="pt-calendar-weekday">
          {weekday}
        </div>
      ))}
    </div>

    {weeks.map((week, weekIndex) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className="pt-calendar-week" key={`week-${weekIndex}`}>
        {week.map((cell) => {
          const dayItems = itemsByDate[cell.dateKey] || [];
          const visualStatus = getDayVisualStatus(dayItems);
          const statuses = getDayStatuses(dayItems);
          const isSelected = selectedDateKey === cell.dateKey;

          return (
            <button
              type="button"
              key={cell.dateKey}
              className={getDayClassName(
                visualStatus,
                isSelected,
                cell.currentMonth,
              )}
              onClick={() => onSelectDate(cell.dateKey)}
            >
              <div className="pt-calendar-day-number">{cell.day}</div>

              {dayItems.length > 0 && (
                <div className="pt-calendar-day-summary">
                  {statuses.map((statusKey) => {
                    const statusConfig =
                      PREVENTIVE_TASK_STATUS_ACTIVITY[statusKey];

                    return (
                      <div key={statusKey} className="pt-calendar-status-item">
                        <span
                          className={`pt-calendar-status-dot pt-calendar-status-dot-${statusKey
                            .toLowerCase()
                            .replace('_', '-')}`}
                        />

                        <span className="pt-calendar-status-label">
                          {statusConfig ? statusConfig.label : statusKey}
                        </span>
                      </div>
                    );
                  })}

                  <small className="pt-calendar-day-count">
                    {dayItems.length} act.
                  </small>
                </div>
              )}
            </button>
          );
        })}
      </div>
    ))}
  </div>
);

PreventiveTaskProjectionMonthGrid.propTypes = {
  weeks: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  itemsByDate: PropTypes.shape({}).isRequired,
  selectedDateKey: PropTypes.string,
  onSelectDate: PropTypes.func.isRequired,
};

PreventiveTaskProjectionMonthGrid.defaultProps = {
  selectedDateKey: null,
};

export default PreventiveTaskProjectionMonthGrid;
